namespace GeniuzPOS.InitialData {
    export interface PsPriceOverrideReasonForm {
        PriceOverrideId: Serenity.IntegerEditor;
        PriceOverrideReason: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class PsPriceOverrideReasonForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPriceOverrideReason';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPriceOverrideReasonForm.init)  {
                PsPriceOverrideReasonForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PsPriceOverrideReasonForm, [
                    'PriceOverrideId', w0,
                    'PriceOverrideReason', w1,
                    'Remark', w1
                ]);
            }
        }
    }
}
